import {Resource} from '~/app/core/common/resource';

export class ConfirmationItem extends Resource {
    trackingId: string;
    itemNumber: string;
    description: string;
    price: number;
    quantity: number;
    reason: string;
    totalPrice: number;
}
